import { Component, OnInit } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { ModalCreateMenuComponent } from '@cms/system/modal/modal-create-menu/modal-create-menu.component'
import { KetshopwebFrontendService } from '@cms/services/ketshopweb-frontend.service'
import {
  MenuSettingInitStore,
  MenuSettingStore,
  MenuListStore,
  MenuSettingSelectorLevel1,
} from '@cms/store/MenuSetting'
import { KetshopwebServices } from 'ketshopweb-services'

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  constructor(
    private modal: NzModalService,
    private ketshopwebFrontendService: KetshopwebFrontendService,
    private FrontendService: KetshopwebServices.FrontendService,
  ) {}

  MenuSettingStore = MenuSettingStore
  MenuSettingSelectorLevel1 = MenuSettingSelectorLevel1

  async ngOnInit() {
    MenuSettingInitStore(this.FrontendService).then(() => {
      console.log('MenuSettingInitStore')
    })
    this.ketshopwebFrontendService.getMenuPageList().then((res) => {
      MenuListStore.set(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        res.map((x: any) => {
          return {
            ...x,
            enable: Boolean(x.enable),
            lang1: x.lang1,
            page_id: x.page_id,
            page_parent: x.page_parent,
            page_sort: x.page_sort,
            showinmenu: Boolean(x.showinmenu),
            childrens: [],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: x.type as any,
          }
        }),
      )
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  create(type: any) {
    // const width = type == 'product' || type == 'blog' ? '80%' : '60%'
    const modal = this.modal
      .create({
        nzTitle: 'สร้างเมนู',
        nzContent: ModalCreateMenuComponent,
        nzWrapClassName: 'vertical-center-modal',
        nzWidth: '60%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
        nzOnCancel: () => {},
        nzComponentParams: {
          data: {
            type: type,
          },
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        this.ketshopwebFrontendService.getMenuPageList().then((res) => {
          console.log('result', result)
          const find = res.find((x) => x.page_id == result.page_id) as any
          if (find) {
            MenuListStore.set([
              ...MenuListStore.get(),
              {
                ...find,
                enable: Boolean(find.enable),
                lang1: find.lang1,
                page_id: find.page_id,
                page_parent: find.page_parent,
                page_sort: find.page_sort,
                showinmenu: Boolean(find.showinmenu),
                childrens: [],
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                type: find.type as any,
              },
            ])
          }
          $('.theme-loader').fadeOut()
        }).catch((e) => {
          $('.theme-loader').fadeOut()
        })
      })
  }

  Save() {
    $('.theme-loader').fadeIn()
    this.FrontendService.SaveMenuSetting(MenuSettingStore.get().changing)
      .then(async (res) => {
        console.log(res)
        await MenuSettingInitStore(this.FrontendService)
        $('.theme-loader').fadeOut()
      })
      .catch((e) => {
        console.error(e)
        $('.theme-loader').fadeOut()
      })
  }
}
